import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
@Component({
  selector: 'app-chip-filter',
  standalone: true,
  imports: [CommonStandaloneModule, MatIconModule],
  templateUrl: './chip-filter.component.html',
  styleUrls: ['./chip-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipFilterComponent {
  @Input() icon: string;
  @Input() iconStyle: string;
  @Input() active: boolean;
  @Input() count: number;
}
